import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import Menu from './components/common/Menu';
import SaldoContas from './components/home/SaldoContas';
import Reset from './components/home/Reset';
import LoginForm from './components/autenticacao/LoginForm';
import Logout from './components/autenticacao/Logout';
import RegistroForm from './components/autenticacao/RegistroForm';
import Contas from './components/contas/Contas';
import MovimentacaoForm from './components/movimentacao/MovimentacaoForm';
import ExtratoMensal from './components/relatorios/ExtratoMensal';
import { apagarMensagem } from './redux/actions/mensagemAction';
import createHistory from 'history/createBrowserHistory';
import './App.css';
import PrivateRoute from './components/autenticacao/PrivateRoute';

const ReactToastr = require("react-toastr");
const { ToastContainer } = ReactToastr;

const history = createHistory();

class App extends Component {

	componentWillReceiveProps(nextProps) {
		if (nextProps.mensagem && nextProps.mensagem.tipo) {
			switch (nextProps.mensagem.tipo) {
				case 'yay': this.container.success(nextProps.mensagem.texto, "", { closeButton: true }); break;
				case 'err': this.container.error(nextProps.mensagem.texto, "", { closeButton: true }); break;
				case 'info': this.container.info(nextProps.mensagem.texto, "", { closeButton: true }); break;
				case 'warn': this.container.warning(nextProps.mensagem.texto, "", { closeButton: true }); break;
				default: this.container.warning(nextProps.mensagem.texto, "Não informou tipo correto...", { closeButton: true }); break;
			}

			this.props.apagarMensagem();
		}
	}

	checkLogin = () => {
		if (!this.props.nomeUsuario) {
			return <Redirect to="/login" />;
		}
	}

	render() {
		const ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);

		return (
			<ConnectedRouter history={history}>
				<div>
					<Menu />
					<div className="container">
						<ToastContainer ref={(input) => { this.container = input; }}
							toastMessageFactory={ToastMessageFactory}
							className="toast-top-right"
							preventDuplicates />
						<PrivateRoute exact path="/" component={SaldoContas} canActivate={this.props.nomeUsuario} />
						<PrivateRoute exact path="/reset" component={Reset} canActivate={this.props.nomeUsuario} />
						<Route path="/login" component={LoginForm} />
						<Route path="/registro" component={RegistroForm} />
						<PrivateRoute path="/logout" component={Logout} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/contas" component={Contas} canActivate={this.props.nomeUsuario} />
						<PrivateRoute exact path="/movimentacao" component={MovimentacaoForm} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/movimentacao/:id" component={MovimentacaoForm} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/extrato" component={ExtratoMensal} canActivate={this.props.nomeUsuario} />
						<hr />
					</div>
					<footer className="footer text-center" style={{ color: '#777' }}>
						
						<p><small>Seu Barriga - Nunca mais esqueça de pagar o aluguel.</small></p>
					</footer>
				</div>
			</ConnectedRouter>
		);
	}
}

App.propTypes = {
	nomeUsuario: PropTypes.string.isRequired,
	mensagem: PropTypes.object,
	apagarMensagem: PropTypes.func.isRequired,
};

function mapStateToProps({ nomeUsuario, mensagem }) {
	return {
		nomeUsuario,
		mensagem
	};
}

function mapDispatchToProps(dispatch) {
	return {
		apagarMensagem: () => dispatch(apagarMensagem())
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js